module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_playworks.811a702d40c543144f64817490387cad.png";